import { Grid } from "@material-ui/core";
import React, { useContext, useState } from "react";

import DataTable from "../../ui/DataTable/DataTable";

import CustomDialog from "../../ui/CustomDialog/CustomDialog";

import EmployeeForm from "../EmployeeForm";

import { EmployeeContext } from "../../context/EmployeeContext/EmployeeContext";
import { AuthContext } from "../../context/AuthContext/AuthContext";

export default function EmployeeTable() {
  const { employees, loading, setSelectedEmployee, getEmployeeDataAll } = useContext(EmployeeContext)
  const { updateUserAuthByAdmin, deleteUserAuthByAdmin } = useContext(AuthContext)

  const [showModal, setShowModal] = useState(false);

  const handleEditAction = (rowData) => {
    setSelectedEmployee(rowData)
    setShowModal(true);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12} lg={12}>
        <DataTable
          search={false}
          isLoading={loading}
          grouping={true}
          exportButton={true}
          paging={true}
          title={'Employees'}
          columns={[
            { title: "Name", field: "name" },
            { title: "Email", field: "email" },
            { title: "Address", field: "address" },
            { title: "Phone Number", field: "phoneNumber" },
            { title: "Created By", field: "createdBy.name" },
            { title: "Modified By", field: "modifiedBy.name" },
          ]}
          data={employees ? employees : []}
          editable={{
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                resolve();
                deleteUserAuthByAdmin(oldData.id);
                getEmployeeDataAll()
              }),
          }}
          actions={[
            {
              icon: "edit",
              tooltip: "Edit Employee",

              onClick: (event, rowData) => handleEditAction(rowData),
            },
            {
              icon: "block",
              tooltip: "Disable User",
              onClick: (event, rowData) => {
                updateUserAuthByAdmin(rowData.id, { disabled: true });
              },
            },
            {
              icon: "vpn_key",
              tooltip: "Enable User",
              onClick: (event, rowData) => {
                updateUserAuthByAdmin(rowData.id, { disabled: false });
              },
            },
            {
              icon: "lock_open",
              tooltip: "Reset password",
              onClick: (event, rowData) => {
                updateUserAuthByAdmin(rowData.id, {
                  password: rowData.phoneNumber,
                });
              },
            },
          ]}
        />
      </Grid>

      {/* showModal */}
      <CustomDialog
        maxWidth={"md"}
        title={"Edit Employee"}
        buttonCaption="Edit"
        open={showModal}
        setOpen={setShowModal}
      >
        <EmployeeForm
          setOpen={setShowModal}
          action={1}
        />
      </CustomDialog>
    </Grid>
  );
}
